import { NOT_SET } from './constants';

const determineLinkedCEO = (user?: any): string => {
  if (!user) return NOT_SET;
  const { shoppingWithCeoUser, conciergeUser, permissions, userId } = user;
  const isCeo =
    permissions &&
    permissions.oneCommerce &&
    permissions.oneCommerce.ceo &&
    permissions.oneCommerce.ceo.access;
  switch (true) {
    case !!shoppingWithCeoUser:
      return shoppingWithCeoUser.userId;
    case !!conciergeUser:
      return userId;
    case isCeo:
      return userId;
    default:
      return NOT_SET;
  }
};

export default determineLinkedCEO;
